/*const ipFile = require('../../build/ip')
const HOST = ipFile.getIp()*/
const HOST = process.env.HOST
const ipFile = require('../../build/ip')
const host = HOST || ipFile.getIp() === '127.0.0.1' ? window.location.host : ipFile.getIp()
const proto = window.location.protocol || 'http'
const httpProto = proto.indexOf('https')>0?'https':'http'
const wsProto = httpProto === 'https'? 'wss':'ws'
//const host = '10.1.20.133'
export default {
  /**
   * 显示在浏览器标签的title
   */
  title: 'IP 广播对讲系统',
  sys_version: 'V2.1.2.01',
  //server_ip: '10.1.20.133',
  server_ip: '192.168.31.130',
  wsPort: '7066',
  wssPort: '7067',
  ws: wsProto + '://'+host+'/DisWebSocket/websocket',
  sysUrl: httpProto + '://'+host+'/control',
  cookieExpires: 30,//token 存储 cookie 时间 单位：天
  useI18n: true,
  baseUrl: {
    dev: httpProto + '://'+host+'/',
    pro:httpProto + '://'+host+'/'
  },
  homeName:'control',
  plugin: {
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js